import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { NavBarUsuarioComponent } from './nav-bar-usuario/nav-bar-usuario.component';
import { MaterialModule } from '../material/material.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { CintaSuperiorComponent } from './cinta-superior/cinta-superior.component';
import { CintaInferiorComponent } from './cinta-inferior/cinta-inferior.component';
@NgModule({
  declarations: [
    FooterComponent,
    SidebarComponent,
    NavbarComponent,
    NavBarUsuarioComponent,
    CintaSuperiorComponent,
    CintaInferiorComponent


  ],
  exports: [
    FooterComponent,
    SidebarComponent,
    NavbarComponent,
    NavBarUsuarioComponent,
    CintaSuperiorComponent,
    CintaInferiorComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    MatExpansionModule
  ]
})
export class ComponentsModule { }
